import React, { useMemo, useState } from "react";

function getPasswordStrength(password) {
  let score = 0;
  if (password.length >= 10) score += 1;
  if (/[A-Z]/.test(password) && /[a-z]/.test(password)) score += 1;
  if (/\d/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password)) score += 1;
  return score;
}

export default function RegistrationAccountForm({
  onSubmit,
  submitting,
  submitLabel = "Continue to verification",
  emailLabel = "Work email",
  emailPlaceholder = "name@company.co.za",
  invitation,
}) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const strength = useMemo(() => getPasswordStrength(password), [password]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    onSubmit({
      firstName: String(data.get("firstName") || "").trim(),
      surname: String(data.get("surname") || "").trim(),
      email: String(data.get("email") || "").trim(),
      password,
    });
  };

  return (
    <form className="pa-form pa-registration-form" onSubmit={handleSubmit}>
      <div className="pa-field-grid">
        <label className="pa-field">
          <span>First name</span>
          <input name="firstName" autoComplete="given-name" defaultValue={invitation?.firstName || ""} required />
        </label>
        <label className="pa-field">
          <span>Surname</span>
          <input name="surname" autoComplete="family-name" defaultValue={invitation?.surname || ""} required />
        </label>
      </div>

      <label className="pa-field">
        <span>{emailLabel}</span>
        <input
          name="email"
          type="email"
          autoComplete="email"
          placeholder={emailPlaceholder}
          defaultValue={invitation?.email || ""}
          required
        />
        <small>
          {invitation
            ? `This must match the address invited to ${invitation.companyDisplayName || "this workspace"}.`
            : "A Firebase verification email will be sent to this address."}
        </small>
      </label>

      {invitation ? (
        <div className="pa-invitation-workspace">
          <span>Invited workspace</span>
          <strong>{invitation.companyDisplayName || "AndUs tenant"}</strong>
          {invitation.maskedEmail ? <small>Invitation for {invitation.maskedEmail}</small> : null}
        </div>
      ) : null}

      <label className="pa-field">
        <span>Create password</span>
        <div className="pa-input-control is-plain">
          <input
            name="password"
            type={showPassword ? "text" : "password"}
            autoComplete="new-password"
            minLength={10}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          <button type="button" onClick={() => setShowPassword((visible) => !visible)}>
            {showPassword ? "Hide" : "Show"}
          </button>
        </div>
        <div className="pa-password-strength" data-strength={strength}>
          {[1, 2, 3, 4].map((level) => <span key={level} className={strength >= level ? "is-active" : ""} />)}
          <small>{password ? ["", "Basic", "Good", "Strong", "Excellent"][strength] : "Use 10+ characters, uppercase, a number and a symbol"}</small>
        </div>
      </label>

      <label className="pa-check">
        <input name="terms" type="checkbox" required />
        <span aria-hidden="true" />
        <span>I agree to the AndUs Terms of Use and Privacy Notice supplied by my organisation.</span>
      </label>

      <button className="pa-primary-button" type="submit" disabled={submitting}>
        <span>{submitting ? "Creating account…" : submitLabel}</span>
        <span aria-hidden="true">›</span>
      </button>
    </form>
  );
}
